import { createRouter, createWebHistory } from 'vue-router';

import apresentacao from '@/containers/apresentacao.vue';
import comissoes from '@/containers/comissoes.vue';
import composicao from '@/containers/composicao.vue';
import eleicoes from '@/containers/eleicoes.vue';
import noticiaseventos from '@/containers/noticiaseventos.vue';
import regulamentos from '@/containers/regulamentos.vue';
import reunioes from '@/containers/reunioes.vue';
import reuniao from '@/containers/reuniao.vue';
import noticiaevento from '@/containers/noticiaevento.vue';
import eleicao from '@/containers/eleicao.vue';

let baseUrl = window.lang == "en" ?
    import.meta.env.VITE_APP_BASEURLEN :
    import.meta.env.VITE_APP_BASEURL;

const router = createRouter({
  history: createWebHistory(baseUrl),
  routes: [ 
    { name: "conselhogeral", path: '/', component: apresentacao },
    { name: "composicao", path: '/composicao', component: composicao },
    { name: "comissoes", path: '/comissoes', component: comissoes },
    { name: "reuniao", path: '/reunioes/:id', component: reuniao },
    { name: "reunioes", path: '/reunioes', component: reunioes },
    { name: "eleicao", path: '/processos-eleitorais/:id', component: eleicao },
    { name: "eleicoes", path: '/processos-eleitorais', component: eleicoes },
    { name: "noticia", path: '/noticias-e-eventos/:id', component: noticiaevento },
    { name: "noticiaseventos", path: '/noticias-e-eventos', component: noticiaseventos },
    { name: "regulamentos", path: '/regulamentos', component: regulamentos },
    { path: '/', redirect: '/' },
    { path: "/:catchAll(.*)", redirect: '/'} 
  ],
  scrollBehavior() {
    return { top: 0 }
  },
})

export default router;
